import { useState } from "react"

import { AxiosError } from "axios"
import { isCleverRestrictedError } from "utils/api"

export const useCleverRestrictedError = () => {
  const [isLocked, setIsLocked] = useState(false)

  const handleCleverRestrictedError = (error: AxiosError) => {
    const restricted = isCleverRestrictedError(error)
    if (restricted) setIsLocked(true)
    return restricted
  }

  const resetLock = () => setIsLocked(false)

  return { isLocked, handleCleverRestrictedError, resetLock }
}
